import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {RecordSectionKey} from "../utils/branchDiff";
import {ensureSectionCollection} from "./sectionCollections";
import {identityOf} from "../utils/migrateRecord";

// Removes a record (and, optionally, its image pack) from an array section on
// Current — propagating a deletion Other already made (the record exists only
// on Current). Localization rows are intentionally left in place: loc keys are
// cheap, frequently shared, and silently dropping them risks orphaning text
// other records rely on. The reference-integrity guard lives in the classifier
// (classifyRecordRemoval) — this command performs the write.
export class RemoveRecordCommand extends CommandBase {
    sectionKey: RecordSectionKey;
    identity: string;

    constructor(sectionKey: RecordSectionKey, identity: string) {
        super();
        this.sectionKey = sectionKey;
        this.identity = identity;
    }

    execute(data: RemoteConstantsModel): boolean {
        const collection = ensureSectionCollection(data, this.sectionKey);
        if (!collection) return false;

        const index = collection.findIndex(r => identityOf(r, this.sectionKey) === this.identity);
        if (index < 0) return false;

        collection.splice(index, 1);

        // Drop the record's image pack — it's keyed by the record's identity and
        // nothing else can reference that slot once the record is gone.
        if (data.imagePacks && this.identity in data.imagePacks) {
            delete data.imagePacks[this.identity];
        }

        return true;
    }
}
